<template>
  <div class="contentBox" v-title title="统计模块">
    <navBox :id="navId"></navBox>

    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>学员姓名:</p>
          <input type="text" placeholder="请输入要搜索的学员姓名">
        </div>
        <div class="search-item">
          <p>是否及格：:</p>
          <select>
            <option :value="item.id" v-for="item in topicType" v-bind:key="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="btnBox">
          <button class="btn btn-search">搜索</button>
          <button class="btn btn-reset">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>统计模块</p>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="(index+1)">{{(index+1)}}</p>
              <p :title="item.exam">{{item.exam}}</p>
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.date">{{item.date}}</p>
              <p :title="item.pass==0?'不及格':'及格'">{{item.pass==0?'不及格':'及格'}}</p>
              <p :title="item.num">{{item.num}}</p>
              <p :title="item.num1">{{item.num1}}</p>
              <p :title="item.num2">{{item.num2}}</p>
              <p :title="item.answer">{{item.answer}}%</p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage1"
              :page-size="100"
              layout="prev, pager, next, jumper"
              :total="1000">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 删除提示框 -->
    <div class="msgBox removeBox" v-if="removeType">
      <div class="contv">
        <p class="title">提示</p>
        <p class="txt">确认删除此项数据吗？</p>
        <div class="btnBox">
          <button class="btn btn-remove" @click="removeSub">删除</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "exam",
  data() {
    return {
      navId:'4',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'考试名称'},
        {id:3,title:'用户ID'},
        {id:4,title:'姓名'},
        {id:5,title:'提交时间'},
        {id:6,title:'是否及格'},
        {id:7,title:'得分'},
        {id:8,title:'正确题数'},
        {id:9,title:'错误题数'},
        {id:10,title:'答对率'},
      ],
      dataList:[
        {id:1,exam:'dada',name:'dadadas',date:'2020-20-20',pass:1,num:10,num1:20,num2:30,answer:20},
        {id:1,exam:'dada',name:'dadadas',date:'2020-20-20',pass:1,num:10,num1:20,num2:30,answer:20},
        {id:1,exam:'dada',name:'dadadas',date:'2020-20-20',pass:1,num:10,num1:20,num2:30,answer:20},
        {id:1,exam:'dada',name:'dadadas',date:'2020-20-20',pass:1,num:10,num1:20,num2:30,answer:20},
        {id:1,exam:'dada',name:'dadadas',date:'2020-20-20',pass:1,num:10,num1:20,num2:30,answer:20},
        {id:1,exam:'dada',name:'dadadas',date:'2020-20-20',pass:1,num:10,num1:20,num2:30,answer:20},
        {id:1,exam:'dada',name:'dadadas',date:'2020-20-20',pass:1,num:10,num1:20,num2:30,answer:20},
        {id:1,exam:'dada',name:'dadadas',date:'2020-20-20',pass:1,num:10,num1:20,num2:30,answer:20},
        {id:1,exam:'dada',name:'dadadas',date:'2020-20-20',pass:1,num:10,num1:20,num2:30,answer:20},
        {id:1,exam:'dada',name:'dadadas',date:'2020-20-20',pass:1,num:10,num1:20,num2:30,answer:20},
        {id:1,exam:'dada',name:'dadadas',date:'2020-20-20',pass:1,num:10,num1:20,num2:30,answer:20},
        {id:1,exam:'dada',name:'dadadas',date:'2020-20-20',pass:1,num:10,num1:20,num2:30,answer:20},
      ],
      currentPage1: 2,
      removeType:false,
      topicType:[
        {id:1,title:'单选题'},
        {id:2,title:'多选题'},
        {id:3,title:'判断题'},
      ],
      showType:'list',
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },

    
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: 10%;
}

</style>



// WEBPACK FOOTER //
// src/statistics/index.vue